<template>
  <div class="mask">
    <div class="popup-wrap">
      <!-- 头部 -->
      <div class="popup-header">
        <div class="popup-header-left">设置</div>
        <div class="popup-header-right"></div>
      </div>
      <!-- 内容 -->
      <div class="popup-content">
        <div class="popup-content-left">
          <!-- <div style="color: rgb(230, 228, 228)">选择播放设备</div>      -->
          <div style="color: rgb(230, 228, 228)">建议使用耳机体验！</div>
          <!-- <div>
            <select
              v-model="activeValue"
              class="popup-content-left-select"
              @change="audioRadioChange"
            >
              <option
                v-for="item in audioList"
                :key="item.deviceId"
                :value="item.deviceId"
              >
                {{ item.label }}
              </option>
            </select>
          </div> -->
          <!-- <div
            v-if="activeValue == '1'"
            class="popup-content-btn"
            @click="test"
          >
            测试
          </div> -->
          <!-- <div
						v-else
						class="popup-content-btn"
						@click="$emit('test')"
					>
						扬声器设置
					</div> -->
        </div>

        <div class="popup-content-conter">
          <div class="popup-content-conter-top">
            <div class="img">
              <img src="/space/images/you.svg" alt="" />
            </div>
            <div class="title">这是您的坐标</div>
            <div class="info">您可以使用键盘四处走走</div>
          </div>

          <div class="popup-content-conter-bottom">
            <div class="img">
              <img src="/space/images/audioI.svg" alt="" />
            </div>
            <div class="title">这是一个声源</div>
            <div class="info">双击可以播放，可以拖动声源</div>
          </div>
        </div>

        <div class="popup-content-right">
          <div style="color: rgb(230, 228, 228)">可用键盘操作</div>
          <div class="keyboard">
            <div class="keyboard-q">
              <div>Q</div>
            </div>
            <div class="keyboard-w">
              <div class="triangle"></div>
              <div>W</div>
            </div>
            <div class="keyboard-e">
              <div>E</div>
            </div>
            <div class="keyboard-a">
              <div class="triangle"></div>
              <div>A</div>
            </div>
            <div class="keyboard-s">
              <div class="triangle"></div>
              <div>S</div>
            </div>
            <div class="keyboard-d">
              <div class="triangle"></div>
              <div>D</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="popup-footer">
        <div>2022-2032 © All Right Reserved by WANOS</div>
        <button
          @click="
            $emit('close');
            $emit('begin');
          "
        >
          进入体验场
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeValue: "1",
      audioList: [],
    };
  },
  mounted() {
    // this.getSpeakerList();
  },
  methods: {
    // 获取设备列表
    getSpeakerList() {
      // 检测浏览器的支持情况
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        throw new Error("enumerateDevices is not supported");
      }
      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          let list = [];
          devices.forEach(function (device) {
            if (device.kind === "audiooutput") {
              device.value = device.deviceId;
              list.push(device);
            }
          });
          this.audioList = list;
          this.activeValue = list[0].deviceId;
        })
        .catch(function (err) {
          console.log(err.name + ": " + err.message);
        });
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error("getUserMedia is not supported");
      }
      // 调用音频和视频设备
      // navigator.mediaDevices.getUserMedia({ audio: true });
    },
    audioRadioChange() {
      // this.$bus.emit("audioRadioChange", this.activeValue);
    },
    test() {
      console.log("播放测试音频");
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.mask {
  position: fixed;
  top: 0%;
  left: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  .popup-wrap {
    background: #21242d;
    margin: 30px;
    border-radius: 5px;
  }
}
.popup-header {
  border-radius: 5px 5px 0 0;
  height: 42px;
  background: #2b2f38;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  color: white;
  font-size: 12px;
}
.popup-content {
  width: 100%;
  height: 230px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .popup-content-left {
    width: 220px;
    height: 150px;
    border: solid 1px #62656e;
    border-radius: 72px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 20px 0;
    margin: 0 20px;
    align-items: center;
    line-height: 35px;
    .popup-content-btn {
      font-size: 12px;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      justify-content: center;
      align-items: center;
      padding: 4px 10px;
      gap: 10px;
      color: #ffffff;
      width: 64px;
      height: 25px;
      background: #464d59;
      border-radius: 4px;
    }
    .popup-content-left-select {
      width: 130px;
      border: 1px solid #62656e;
      background: #21242d;
      border-radius: 5px;
      color: rgb(230, 228, 228);
      font-size: 14px;
      outline: none;
      padding: 5px;
      margin-bottom: 13px;
    }
  }
  .popup-content-conter {
    width: calc(100% - 537px);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    text-align: center;
    .popup-content-conter-top {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-size: 12px;
      .img {
        width: 40px;
        height: 40px;
        margin: 0 auto;
      }
      .title {
        color: #bbc8e5;
        font-weight: 500;
      }
      .info {
        margin-top: 2px;
        margin-left: -3px;
        width: 132px;
        height: 14px;

        color: #585967;
        font-weight: 400;
      }
    }
    .popup-content-conter-bottom {
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      font-size: 12px;
      .img {
        width: 40px;
        height: 40px;
        margin: 0 auto;
      }
      .title {
        color: #bbc8e5;
        font-weight: 500;
      }
      .info {
        margin-top: 2px;
        margin-left: -14px;
        width: 156px;
        height: 14px;
        color: #727c94;
        font-weight: 400;
        white-space: nowrap;
      }
    }
  }
  .popup-content-right {
    margin: 0 20px;
    width: 220px;
    height: 150px;
    border: solid 1px #62656e;
    border-radius: 72px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    padding: 12px 0;
    .keyboard {
      width: 80%;
      margin: 0 auto;
      padding: 6px 18px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .keyboard-q {
        color: #bbc8e5;
        width: 36px;
        height: 36px;
        border: solid 1px #ccc;
        border-radius: 4px;
        margin: 5px;
        display: flex;
        flex-direction: column;
        line-height: 36px;
      }
      .keyboard-w {
        color: #bbc8e5;
        width: 36px;
        height: 36px;
        border: solid 1px #ccc;
        border-radius: 4px;
        margin: 5px;
        display: flex;
        flex-direction: column;
        .triangle {
          display: block;
          margin: 6px auto 0px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #ccc;
        }
      }
      .keyboard-e {
        color: #bbc8e5;
        width: 36px;
        height: 36px;
        border: solid 1px #ccc;
        border-radius: 4px;
        margin: 5px;
        display: flex;
        flex-direction: column;
        line-height: 36px;
      }
      .keyboard-a {
        width: 36px;
        height: 36px;
        border: solid 1px #ccc;
        border-radius: 4px;
        margin: 5px;
        display: flex;
        flex-direction: column;
        color: #bbc8e5;
        .triangle {
          display: block;
          margin: 5px auto -2px;
          border-top: 4px solid transparent;
          border-right: 5px solid #ccc;
          border-bottom: 4px solid transparent;
        }
      }
      .keyboard-s {
        color: #bbc8e5;
        width: 36px;
        height: 36px;
        border: solid 1px #ccc;
        border-radius: 4px;
        margin: 5px;
        display: flex;
        flex-direction: column;
        .triangle {
          display: block;
          margin: 6px auto 0px;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #ccc;
        }
      }
      .keyboard-d {
        color: #bbc8e5;
        width: 36px;
        height: 36px;
        border: solid 1px #ccc;
        border-radius: 4px;
        margin: 5px;
        display: flex;
        flex-direction: column;
        .triangle {
          display: block;
          margin: 5px auto -2px;
          width: 0;
          height: 0;
          border-top: 4px solid transparent;
          border-left: 5px solid #ccc;
          border-bottom: 4px solid transparent;
        }
      }
    }
  }
}
.popup-footer {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  border-top: solid 1px #000;
  color: #ccc;
  div {
    color: #727c94;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #727c94;
    opacity: 0.6;
  }
  button {
    background: linear-gradient(180deg, #3d3dfc -12.5%, #1c1cb7 163.24%);
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.16);
    color: white;
    border: none;
    height: 28px;
    width: 100px;
    cursor: pointer;
    font-size: 12px;
    border-radius: 4px;
  }
}
</style>
